module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      'sneaky-mode': _vm.sneakyMode
    }
  }, [_c('router-link', {
    staticClass: "logo img",
    attrs: {
      "to": "/"
    }
  }), _vm._v(" "), (_vm.showNav && _vm.user.id) ? _c('el-menu', {
    staticClass: "nav logged-in",
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.$route.path
    }
  }, [_c('el-menu-item', {
    class: {
      'is-active': _vm.$route.name === 'category'
    },
    attrs: {
      "index": "projects"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.myProjects')))])], 1), _vm._v(" "), (_vm.organization) ? _c('el-menu-item', {
    class: {
      'is-active': _vm.$route.name === 'members'
    },
    attrs: {
      "index": "members"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/members",
      "tag": "div"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.members')))])], 1) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    class: {
      'is-active': _vm.$route.name === 'price'
    },
    attrs: {
      "index": "price"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/price",
      "tag": "div"
    }
  }, [_vm._v("会员服务")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "help-menu-item",
    attrs: {
      "index": "help"
    }
  }, [_c('a', {
    staticClass: "block-btn",
    attrs: {
      "href": "http://ppj.io/docs/",
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.headbar.help')) + "\n        ")])]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "avatar-wrapper",
    attrs: {
      "index": "avatar"
    }
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "popper-class": "sub-menu header-popover",
      "trigger": "hover",
      "placement": "bottom-end",
      "width": "160"
    }
  }, [_c('router-link', {
    staticClass: "sub-menu-item",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.myAccount')))]), _vm._v(" "), _c('a', {
    staticClass: "sub-menu-item",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.logout')))])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }]
  }, [_c('div', {
    staticClass: "avatar img",
    style: ({
      backgroundImage: 'url(' + _vm.user.profile_picture + ')'
    })
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showNav && !_vm.user.id) ? _c('div', {
    staticClass: "nav no-logged-in"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.path !== "/login"),
      expression: "this.$route.path !== \"/login\""
    }],
    attrs: {
      "to": "login",
      "tag": "el-button"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.headbar.login')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!/^\/register/.test(this.$route.path)),
      expression: "!/^\\/register/.test(this.$route.path)"
    }],
    attrs: {
      "to": "/register",
      "tag": "el-button"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.headbar.register')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.path !== '/price'),
      expression: "this.$route.path !== '/price'"
    }],
    attrs: {
      "to": "/price",
      "tag": "el-button"
    }
  }, [_vm._v("\n      会员服务\n    ")])], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9b08b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/headbar.vue
// module id = 944
// module chunks = 3